// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3_B7q","rootCenter":"LoadMoreObserver_rootCenter__1xNhs","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2-Ox4"};